export const BILLING_INVOICE_CREATE_REQUEST = "BILLING_INVOICE_CREATE_REQUEST";
export const BILLING_INVOICE_CREATE_SUCCESS = "BILLING_INVOICE_CREATE_SUCCESS";
export const BILLING_INVOICE_CREATE_FAIL = "BILLING_INVOICE_CREATE_FAIL";

export const BILLING_INVOICE_FETCH_REQUEST = "BILLING_INVOICE_FETCH_REQUEST";
export const BILLING_INVOICE_FETCH_SUCCESS = "BILLING_INVOICE_FETCH_SUCCESS";
export const BILLING_INVOICE_FETCH_FAIL = "BILLING_INVOICE_FETCH_FAIL";
